export default "__VITE_ASSET__0vZvf5Yi__"